export { default as TabHeaderDay } from './Day.tab';
export { default as TabHeaderAct } from './Act.tab';
